import { StyledNoWrap } from "./Questionnaire.styles";

export const QuestionnairePreviewLinkText = ({
    questionnaireName,
}: {
    questionnaireName: string;
}) => {
    const nameParts = questionnaireName.split(" ");

    if (nameParts.length > 0) {
        const allButLastWord = nameParts
            .slice(0, nameParts.length - 1)
            .join(" ");
        const lastWord = nameParts[nameParts.length - 1];

        return (
            <>
                {allButLastWord} <StyledNoWrap>{lastWord}</StyledNoWrap>
            </>
        );
    }

    return <StyledNoWrap>{questionnaireName}</StyledNoWrap>;
};
